import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '../../hooks/use-auth';

interface RedirectUnauthorizedContainerProps {
  redirectTo?: string;
  children?: any;
}

export const RedirectUnauthorizedContainer = ({
  redirectTo = '/login',
  children,
}: RedirectUnauthorizedContainerProps) => {
  const { user } = useAuth();

  return !user ? <Navigate to={redirectTo} replace /> : children || <Outlet />;
};
